import {
  FETCH_BOUNDARIES,
  FETCH_BOUNDARIES_ERROR,
  SET_BOUNDARIES,
  LOG_OUT,
} from '../constants';

import { getTierName, GroupTheBoundaries } from '../../utilities/report-helpers';

const initialState = {
  boundariesDataLoaded: false,
  boundariesData: [],
  boundariesDictionary: {},
};

const parseBoundariesData = data => {
  const boundariesDictionary = {};
  const boundariesData = data.map(tier => ({
    ...tier,
    name: getTierName(tier.type,data),
    options: GroupTheBoundaries(tier.areas,tier.type),
  }));

  boundariesData.forEach(tier => {
    boundariesDictionary[tier.type] = tier;
  });

  return {
    boundariesDictionary,
    boundariesData,
  };
};

const locations = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_BOUNDARIES:
      return {
        ...state,
        boundariesDataLoaded: false,
      };
    case FETCH_BOUNDARIES_ERROR:
      return {
        ...state,
        boundariesDataLoaded: false,
      };
    case SET_BOUNDARIES:
      return {
        ...state,
        boundariesDataLoaded: true,
        ...parseBoundariesData(action.data),
      };
    default:
      return state;
  }
};

export default locations;
